/**
 * zod's settings for the browser. `main.tsx` imports this module first, because modules are
 * evaluated in import order and zod reads the settings when each schema is built, which shared
 * packages such as @morcast/campaigns do as they load.
 *
 * zod compiles object parsers with `Function` when it may, after probing for it. The app's
 * Content-Security-Policy forbids that, and each probe would be reported as a violation, so zod
 * parses without compiling.
 */

import { z } from "zod";

z.config({ jitless: true });
